import styled from "styled-components"

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`

const Taxo = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const StyledDate = styled.p`
  margin: 0;
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const EventItemRecurrence = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { EventsItemImg, Taxo, StyledDate, EventItemRecurrence }
